import { render } from "./StatCardComp.vue?vue&type=template&id=1476a15f&scoped=true"
import script from "./StatCardComp.vue?vue&type=script&lang=js"
export * from "./StatCardComp.vue?vue&type=script&lang=js"

import "./StatCardComp.vue?vue&type=style&index=0&id=1476a15f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1476a15f"]])

export default __exports__